import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translate-service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(private _translate: TranslationService) {}

  transform(value: string, params?: { [key: string]: any }): string {
    if (!value) {
      return '';
    }

    const translation = this._translate.translate(value);

    if (params) {
      return Object.keys(params).reduce((result, key) => {
        const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
        return result.replace(regex, params[key]);
      }, translation);
    }

    return translation;
  }
}
